import store from "./../../../store";
import config from "../components/canvas/store/sqftConfig";
import workspace from "../components/canvas/core/workspace";
import {
  //calculateHypotenuse,
  getBacksplashArea,
  getEdgeLength,
  inchesToLNFT,
  inchesToMm,
  mm2ToM2,
  mmToM,
  sqInchesToSqFoot
} from "./sqftHelper";
import {
  CABINET_BOXES,
  CABINET_FILTER_NAMES,
  RESOURCE_ATTACHED_TO_TYPE,
  SQFT_FEATURES,
  WORKSPACE_RESOURCES
} from "../constants";
import {getCurrentLayout} from "../../appLayout";
import MiteredController from "../components/canvas/core/controls/mitered";
import sqftSlabManager from "../components/canvas/store/sqftSlabManager";
import sqftShapeManager from "../components/canvas/store/sqftShapeManager";
import {SHAPE_LAYOUTS} from "../components/canvas/core/cabinet/cabinetShapes";
import {isShapeTallCabinet} from "./cabinetBoxCompatibilityHelper";
import {
  calculateTallCabinetDoors,
  calculateTallCabinetDrawers,
  calculateTallCabinetHingesForShape,
  calculateTallCabinetKnobs,
  calculateTallCabinetShelves,
  calculateTallCabinetSlideSets,
  getTallCabinetDoorHeight,
  getTallCabinetInteriorQuantities,
  hasTallCabinetInteriorLayout
} from "./tallCabinetInteriorHelper";
//import {findGLBLink, getThirdPartyAR3DMetaData} from "./sqft3dArHelper";

export function manualCalculationsCheckForChangesApplied() {
  return manualCalculationsCountertopArea() > 0 || manualCalculationsEdgesLength() > 0 || manualCalculationsBacksplashArea() > 0
}

//TODO include edges length
export function manualCalculationsCountertopArea() {
  const state = store.getState();

  let totalArea = state.sqftManualCalculationState.countertopRows.reduce((sum, row) => {
    if (!row.length || !row.width || isNaN(row.length) || isNaN(row.width)) {
      return sum
    }

    return config.measureUnit === "Imperial"
      ? sum + Math.ceil(sqInchesToSqFoot(row.length * row.width))
      : sum + mm2ToM2(row.length * row.width)
  }, 0);

  return Math.ceil10(totalArea, -2);
}

export function manualCalculationsEdgesLength() {
  const state = store.getState();
  let totalArea = state.sqftManualCalculationState.edgeRows.reduce((sum, row) => {
    if (!row.length || !row.height || isNaN(row.length) || isNaN(row.height)) {
      return sum
    }

    return sum + manualCalculationsEdgeLength(row.selectedFeature, row.length)
  }, 0);

  return config.measureUnit === "Imperial" ? Math.ceil10(totalArea) : Math.ceil10(totalArea, -2);
}

export function manualCalculationsEdgeLength(selectedFeature, length) {
  return selectedFeature && selectedFeature.dbFeature && selectedFeature.dbFeature.unit.toLowerCase() === "each"
    ? 1
    : config.measureUnit === "Imperial" ? Math.ceil10(inchesToLNFT(length)) : Math.ceil10(mmToM(length), -2);
}

export function manualCalculationsBacksplashArea() {
  const state = store.getState();

  return getRowSum(state.sqftManualCalculationState.backsplashRows);
}
const getRowSum = (row) => {
  let totalArea = row.reduce((sum, row) => {
    if (!row.length || !row.height || isNaN(row.length) || isNaN(row.height)) {
      return sum
    }

    return config.measureUnit === "Imperial"
      ? sum + Math.ceil(sqInchesToSqFoot(row.length * row.height))
      : sum + mm2ToM2(row.length * row.height)
  }, 0);

  return Math.ceil10(totalArea, -2);
}

export function getCountertopArea() {
  let totalArea = 0;
  const shapes = sqftShapeManager.getCounterTopShapes();
  //console.log("-------------------------",);
  shapes
    .sort((a, b) => a.id - b.id)
    .forEach(function(shape) {
      totalArea += shape.getTotalArea();
    });
  //console.log("-------------------------",);
  //console.log("total sqInchesToSqFoot(totalArea)", sqInchesToSqFoot(totalArea));
  return {
    totalAreaToMeasureUnit: config.measureUnit === "Imperial" ? Math.ceil(sqInchesToSqFoot(totalArea)) : mm2ToM2(totalArea),
    totalArea: totalArea,
    shapeLength: shapes.length
  }
}

export function getCabinetsVolume(partIds) {
  let totalVolume = 0;
  const shapes = sqftShapeManager.getCabinetShapes(partIds);
  shapes
    .sort((a, b) => a.id - b.id)
    .forEach(function(shape) {
      totalVolume += shape.getTotalVolume();
    });

  return config.measureUnit === "Imperial" ? Math.ceil(sqInchesToSqFoot(totalVolume)) : mm2ToM2(totalVolume)
}

export function getCabinetsDoorsSQFT(partIds) {
  let totalSQFT = 0;
  const shapes = sqftShapeManager.getCabinetShapes(partIds);
  shapes
    .sort((a, b) => a.id - b.id)
    .forEach((shape) => {
      totalSQFT += getCabinetDoorsSQFT(shape)
    });

  return config.measureUnit === "Imperial" ? Math.ceil10(sqInchesToSqFoot(totalSQFT), -2) : mm2ToM2(totalSQFT);
}

export function getCabinetDoorsSQFT(shape) {
  if (isShapeTallCabinet(shape) && hasTallCabinetInteriorLayout(shape)) {
    return getCabinetLNFT(shape) * getTallCabinetDoorHeight(shape);
  }

  return getCabinetLNFT(shape) * shape.getHeight(true);
}

// export function getCabinetDoorsSQFT(shape) {
//   let totalSQFT = 0;
//   let cathetus = shape.getWidth() - shape.getDepth(true);
//   let lines = shape.getLines();
//
//   switch (shape.shapeParams.shapeLayout) {
//     case SHAPE_LAYOUTS.LowerLCorner: //SHAPE_LAYOUTS.lowerLayoutType1,
//       totalSQFT += (lines[2].getLineLength() + lines[3].getLineLength()) * shape.getDepth(true);
//       break;
//     case SHAPE_LAYOUTS.LowerDullangle: //SHAPE_LAYOUTS.lowerLayoutType2,
//     case SHAPE_LAYOUTS.LowerDualangle: //SHAPE_LAYOUTS.lowerLayoutType2,
//       totalSQFT += lines[1].getLineLength() * shape.getDepth(true) + lines[2].getLineLength() * shape.getDepth(true);
//       break;
//     case SHAPE_LAYOUTS.LowerDimondShape: //SHAPE_LAYOUTS.lowerLayoutType4,
//       totalSQFT += Math.round10(calculateHypotenuse(cathetus, cathetus), -2) * shape.getDepth(true);
//       break;
//     case SHAPE_LAYOUTS.LowerDimondCorner: //SHAPE_LAYOUTS.lowerLayoutType5,
//       totalSQFT += (shape.getWidth() - shape.getDepth(true)) * 2;
//       break;
//     case SHAPE_LAYOUTS.UpperLCorner: // SHAPE_LAYOUTS.upperLayoutType2,
//       totalSQFT += (shape.getWidth() - shape.getDepth(true)) * 2;
//       break;
//     case SHAPE_LAYOUTS.UpperDimondShape: //SHAPE_LAYOUTS.upperLayoutType4,
//       totalSQFT += Math.round10(calculateHypotenuse(cathetus, cathetus), -2);
//       break;
//     case SHAPE_LAYOUTS.UpperDimondCorner: //SHAPE_LAYOUTS.upperLayoutType5,
//       totalSQFT += Math.round10(calculateHypotenuse(cathetus, cathetus), -2);
//       break;
//     case SHAPE_LAYOUTS.LowerIroningBoard: break;//SHAPE_LAYOUTS.lowerLayoutType3,
//     case SHAPE_LAYOUTS.LowerIroningBoardRight: break;//SHAPE_LAYOUTS.lowerLayoutType3,
//     case SHAPE_LAYOUTS.LowerIroningBoardLeft: break;//SHAPE_LAYOUTS.lowerLayoutType3,
//     default:
//       totalSQFT += shape.getWidth() * shape.getDepth(true);
//       break;
//   }
//
//   return config.measureUnit === "Imperial" ? Math.ceil10(sqInchesToSqFoot(totalSQFT), -2) : mm2ToM2(totalSQFT)
// }

export function getCabinetsLNFT(partIds) {
  let totalLength = 0;
  const shapes = sqftShapeManager.getCabinetShapes(partIds);
  shapes
    .sort((a, b) => a.id - b.id)
    .forEach((shape) => {
      totalLength += getCabinetLNFT(shape);
    });

  return totalLength //config.measureUnit === "Imperial" ? Math.ceil(inchesToLNFT(totalLength)) : mm2ToM2(totalLength)
}

export function getCabinetLNFT(shape) {
  let totalLength = 0;
  let lines = shape.getLines();
  switch (shape.shapeParams.shapeLayout) {
    case SHAPE_LAYOUTS.UpperDimondCorner: //SHAPE_LAYOUTS.upperLayoutType5,
    case SHAPE_LAYOUTS.LowerDimondCorner: //SHAPE_LAYOUTS.lowerLayoutType5,
      totalLength += lines[2].getLineLength() + lines[3].getLineLength();
      break;
    case SHAPE_LAYOUTS.UpperLCorner: // SHAPE_LAYOUTS.upperLayoutType2,
    case SHAPE_LAYOUTS.LowerLCorner: //SHAPE_LAYOUTS.lowerLayoutType1,
      totalLength += lines[2].getLineLength() + lines[3].getLineLength();
      break;
    case SHAPE_LAYOUTS.LowerDullangle: //SHAPE_LAYOUTS.lowerLayoutType2,
    case SHAPE_LAYOUTS.LowerDualangle: //SHAPE_LAYOUTS.lowerLayoutType2,
      totalLength += lines[1].getLineLength() + lines[2].getLineLength();
      break;
    case SHAPE_LAYOUTS.UpperDimondShape: //SHAPE_LAYOUTS.upperLayoutType4,
    case SHAPE_LAYOUTS.LowerDimondShape: //SHAPE_LAYOUTS.lowerLayoutType4,
      //totalLength += Math.round10(calculateHypotenuse(cathetus, cathetus), -1);
      totalLength += lines[2].getLineLength();
      break;
    case SHAPE_LAYOUTS.LowerIroningBoard: //SHAPE_LAYOUTS.lowerLayoutType3,
      break;
    case SHAPE_LAYOUTS.LowerIroningBoardRight: //SHAPE_LAYOUTS.lowerLayoutType3,
      break;
    case SHAPE_LAYOUTS.LowerIroningBoardLeft: //SHAPE_LAYOUTS.lowerLayoutType3,
      break;
    default:
      totalLength += lines[0].getLineLength();
      break;
  }

  return totalLength
}

export function getQuantityFromFiltersByShapes(shapes, filterKey) {
  const { filterGroups } = store.getState().filterState;
  let totalQuantity = 0;

  shapes
    .sort((a, b) => a.id - b.id)
    .forEach(function(shape) {
      const feature = shape.getFeature();
      let quantity = 0;
      if (feature) {
        quantity = feature.getFeatureSavedFilterName(filterGroups, filterKey, filterKey);
      }
      totalQuantity += +quantity;
    });

  return totalQuantity;
}

export function getQuantityFromFilters(partIds, filterKey) {
  const shapes = sqftShapeManager.getCabinetShapes(partIds);

  return getQuantityFromFiltersByShapes(shapes, filterKey);
}

const getCabinetFilterQuantities = (shape) => {
  const getFilterQuantity = (filterKey) => (
    getQuantityFromFiltersByShapes([shape], filterKey)
  );

  return {
    doors: getFilterQuantity(CABINET_FILTER_NAMES.doors),
    drawers: getFilterQuantity(CABINET_FILTER_NAMES.drawers),
    knobs: getFilterQuantity(CABINET_FILTER_NAMES.knobs),
    hinges: getFilterQuantity(CABINET_FILTER_NAMES.hinges),
  };
};

const getTallCabinetQuantity = (shape, quantityType) => {
  const interior = getTallCabinetInteriorQuantities(shape);
  const filterQuantities = getCabinetFilterQuantities(shape);

  switch (quantityType) {
    case "doors":
      return calculateTallCabinetDoors(interior, filterQuantities);
    case "drawers":
      return calculateTallCabinetDrawers(interior);
    case "knobs":
      return calculateTallCabinetKnobs(interior);
    case "hinges":
      return calculateTallCabinetHingesForShape(shape, filterQuantities);
    case "slideSets":
      return calculateTallCabinetSlideSets(interior);
    case "shelves":
      return calculateTallCabinetShelves(interior);
    default:
      return 0;
  }
};

const CABINET_QUANTITY_RESOURCE_NAMES = {
  knobs: WORKSPACE_RESOURCES.handles,
  hinges: WORKSPACE_RESOURCES.hinge,
};

const hasAttachedCabinetResource = (shape, quantityType) => {
  const resourceName = CABINET_QUANTITY_RESOURCE_NAMES[quantityType];
  const resources = resourceName && workspace[resourceName];

  return Array.isArray(resources) && resources.some((resource) => resource.shapeId === shape.id);
};

const sumCabinetQuantity = (partIds, quantityType) => {
  const shapes = sqftShapeManager.getCabinetShapes(partIds);

  return shapes.reduce((totalQuantity, shape) => {
    /** Quantity from tall cabinet layout */
    if (isShapeTallCabinet(shape) && hasTallCabinetInteriorLayout(shape)) {
      return totalQuantity + getTallCabinetQuantity(shape, quantityType);
    }

    /** Quantity from filters */
    const filterKey = CABINET_FILTER_NAMES[quantityType];
    const filterQuantity = filterKey
      ? getQuantityFromFiltersByShapes([shape], filterKey)
      : 0;
    return totalQuantity + filterQuantity;
  }, 0);
};

export function getTotalDoors(partIds = CABINET_BOXES) {
  return sumCabinetQuantity(partIds, "doors");
}

export function getTotalKnobs(partIds = CABINET_BOXES) {
  return sqftShapeManager.getCabinetShapes(partIds).reduce((totalQuantity, shape) => {
    if (!hasAttachedCabinetResource(shape, "knobs")) {
      return totalQuantity;
    }

    const quantity = isShapeTallCabinet(shape) && hasTallCabinetInteriorLayout(shape)
      ? getTallCabinetQuantity(shape, "knobs")
      : getQuantityFromFiltersByShapes([shape], CABINET_FILTER_NAMES.knobs);

    return totalQuantity + quantity;
  }, 0);
}

export function getTotalHinges(partIds = CABINET_BOXES) {
  return sqftShapeManager.getCabinetShapes(partIds).reduce((totalQuantity, shape) => {
    if (isShapeTallCabinet(shape) && hasTallCabinetInteriorLayout(shape)) {
      return totalQuantity + getTallCabinetQuantity(shape, "hinges");
    }

    if (!hasAttachedCabinetResource(shape, "hinges")) {
      return totalQuantity;
    }

    return totalQuantity + getQuantityFromFiltersByShapes([shape], CABINET_FILTER_NAMES.hinges);
  }, 0);
}

export function getTotalSlideSets(partIds = CABINET_BOXES) {
  return sumCabinetQuantity(partIds, "slideSets");
}

export function getTotalDrawers(partIds = CABINET_BOXES) {
  return sumCabinetQuantity(partIds, "drawers");
}

export function getTotalShelves(partIds = CABINET_BOXES) {
  return sumCabinetQuantity(partIds, "shelves");
}

export function getEdgesArea() {
  let edgeCount = 0;
  //let edges = workspace.getShapeType('edge');
  const edges = workspace.getAttachedToLineResource(RESOURCE_ATTACHED_TO_TYPE.edge);

  for (const edge of edges) {
    const attachedTo = workspace.getLineOrCornerLineById(edge.attachedToId);
    edgeCount += getEdgeLength(attachedTo);
  }

  if (workspace.miteredController instanceof MiteredController) {
    edgeCount += workspace.miteredController.getEdgesLength();
  }

  return config.measureUnit === "Imperial" ?  Math.ceil(edgeCount) : Math.ceil10(edgeCount, -2);
}

export function getBacksplashTotalArea() {
  let backsplashesArea = 0;
  const state = store.getState();
  const attachedToLineResources = state.sqftResourceState.attachedToLine;
  const backsplashes = attachedToLineResources.filter(attachedToLineResources => attachedToLineResources.type === RESOURCE_ATTACHED_TO_TYPE.backsplash)
  for (let i = 0; i < backsplashes.length; i++) {
    const line = workspace.getLineOrCornerLineById(backsplashes[i].attachedToId)
    if (line) {
      backsplashesArea += getBacksplashArea(line.getBacksplashHeight(), line);
    }
  }

  const backsplashLabeledShapes = sqftShapeManager.getBacksplashLabeledShapes()
  backsplashLabeledShapes.forEach(function(shape) {
    if (shape.getTotalArea) {
      const shapeArea = shape.getTotalArea();
      backsplashesArea += config.measureUnit === "Imperial" ? Math.ceil10(sqInchesToSqFoot(shapeArea), -2) : mm2ToM2(shapeArea)
    }
  });

  return config.measureUnit === "Imperial" ?  Math.ceil10(backsplashesArea) : Math.ceil10(backsplashesArea, -2);
}

export const getConvertedMultipliedValue = (length, height) => {
  return config.measureUnit === "Imperial"
    ? Math.ceil(sqInchesToSqFoot(length * height))
    : mm2ToM2(length * height)
}

export const getExportedManualCalculateBacksplashes = () => {
  const state = store.getState();
  let backsplashes = [];

  state.sqftManualCalculationState.backsplashRows.forEach((row) => {
    if (!row.length || !row.height || isNaN(row.length) || isNaN(row.height)) {
      return
    }
    let area = getConvertedMultipliedValue(row.length, row.height);
    let linearFeet = Math.ceil(inchesToLNFT(row.length)); // / 12
    let M = mmToM(row.length);
    backsplashes.push({
      id: row.id,
      partId: "backsplashes",
      length: area,
      squareFeet: area,
      realLength: config.measureUnit === "Imperial" ? linearFeet : M,
      inputLength: row.length,
      inputHeight: row.height,
    });
  });

  return backsplashes;
}

export const getExportedManualCalculateEdges = () => {
  const state = store.getState();
  let selectedEdges = [];

  state.sqftManualCalculationState.edgeRows.forEach((row) => {
    if (!row.length || !row.height || isNaN(row.length) || isNaN(row.height)) {
      return
    }
    if (!row.selectedFeature) {
      console.log("edge was not selected in manual calculations");
      return
    }
    selectedEdges.push({
      id: row.id,
      featureId: row.selectedFeature.dbFeature.id,
      partId: "edges",
      length: manualCalculationsEdgeLength(row.selectedFeature, row.length),
      unit: row.selectedFeature.dbFeature.unit,
      inputLength: row.length,
      inputHeight: row.height,
      name: row.type,
      segments: 1,
    });
  });

  return selectedEdges;
}

/**
 * @returns string
 */
export const getCountertopQtCategory = () => {
  const layout = getCurrentLayout();
  const mainNeeded = "center_island_countertop";
  const oppositeNeeded = "countertop";
  let featureGroupCountertop = layout.getSubPartFromQtCategories(mainNeeded);
  if (!featureGroupCountertop) {
    return oppositeNeeded
  }

  return mainNeeded
}

/**
 * @returns countertops[]
 */
export const getExportedManualCalculateCountertops = () => {
  const state = store.getState();
  let countertops = [];

  state.sqftManualCalculationState.countertopRows.forEach((row) => {
    if (!row.length || !row.width || isNaN(row.length) || isNaN(row.width)) {
      return
    }
    countertops.push({
      id: row.id,
      partId: getCountertopQtCategory(),
      inputLength: row.length,
      inputWidth: row.width,
      area: getConvertedMultipliedValue(row.length, row.width)
    });
  });

  return countertops;
}

/**
 * This will return area for slabImages and slab placeHolder shapes
 * @return {Number|*|number}
 */
export function getSlabTotalArea() {
  const state = store.getState();
  let slabImages = state.sqftSlabState.croppedSlabImages;
  let slabPlaceHolderShapes = sqftSlabManager.getSlabPlaceHolderShapes();
  if (slabImages.length === 0 && slabPlaceHolderShapes.length === 0) {
    return 0
  }
  let totalArea = [...slabImages, ...slabPlaceHolderShapes].reduce((previousValue, slabImage)  => {
    let imageSize = slabImage.getSize()
    previousValue += imageSize.width * imageSize.depth

    return previousValue
  }, 0)

  return config.measureUnit === "Imperial" ?  Math.ceil10(sqInchesToSqFoot(totalArea)) : Math.ceil10(mmToM(totalArea), -2);
}

export function getSlabImagesAreaGrouped() {
  const state = store.getState();
  const slabImages = state.sqftSlabState.croppedSlabImages;
  const slabPlaceHolderShapes = sqftSlabManager.getSlabPlaceHolderShapes();
  const slabImagesAndPlaceHolders = [...slabImages, ...slabPlaceHolderShapes];

  let slabImagesPrepared = [];
  for (let movableImage of slabImagesAndPlaceHolders) {
    let preparedSlabImage = slabImagesPrepared.find(prepared =>
      prepared.featureId === movableImage.featureId
    );

    if (preparedSlabImage) {
      preparedSlabImage.isDisabledInPopup = preparedSlabImage.isDisabledInPopup && movableImage.isDisabledInPopup;
      continue;
    }

    let totalArea = getSlabSameTypeArea(movableImage.featureId, slabImagesAndPlaceHolders);
    let totalSlabs = getSlabSameType(movableImage.featureId, slabImagesAndPlaceHolders).length;

    slabImagesPrepared.push({
      id: movableImage.id,
      partId: SQFT_FEATURES.slabs,
      slabParentPartId: movableImage.slabParentPartId,
      featureId: movableImage.featureId,
      totalSlabs: totalSlabs,
      totalArea: totalArea,
      pricePerArea: movableImage.pricePerArea,
      shouldUseSlabPricing: movableImage.shouldUseSlabPricing,
      isDisabledInPopup: movableImage.isDisabledInPopup,
      fromWizardGroupId: movableImage.fromWizardGroupId,
      fromWizardId: movableImage.fromWizardId,
      fromWizardStep: movableImage.fromWizardStep,
    });
  }

  return slabImagesPrepared;
}

export function getSlabSameTypeArea(featureId, croppedSlabImages) {
  let totalArea = croppedSlabImages
    .filter(croppedSlabImage => croppedSlabImage.featureId === featureId)
    .reduce((previousValue, slabImage)  => {
      const imageSize = slabImage.getSize();
      const width = config.measureUnit === "Imperial" ?  imageSize.width : inchesToMm(imageSize.width);
      const depth = config.measureUnit === "Imperial" ?  imageSize.depth : inchesToMm(imageSize.depth);
      previousValue += width * depth;

      return previousValue
    }, 0)

  return config.measureUnit === "Imperial" ?  Math.ceil10(sqInchesToSqFoot(totalArea)) : Math.ceil10(mm2ToM2(totalArea), -2);
}

export function getSlabSameType(featureId, croppedSlabImages) {
  return croppedSlabImages.filter(croppedSlabImage => croppedSlabImage.featureId === featureId);
}
